export default "__VITE_ASSET__0e768324__"